import { useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { GetAppendedResultsQueryInitialState } from '@redturtle/qubicaamf-theme/reducers/getAppendedResultsQuery';

export interface RootState {
  getAppendedResultsQuery: GetAppendedResultsQueryInitialState;
}

const useAppendedResults = () => {
  const useTypedSelector: TypedUseSelectorHook<RootState> =
    useSelector<RootState>;

  const results = useTypedSelector((state) => state.getAppendedResultsQuery);

  return results;
};

export { useAppendedResults };
